module.exports = __webpack_public_path__ + "fonts/function-list.svg?8c0a15c8";